import purchasableService from '@/modules/purchasable/services/purchasableService';

const state = {
  // Structure: { [type]: { [itemUid]: purchasable } }
  purchasables: {},
  // Structure: { [uid]: { type, itemUid } }
  uidIndex: {},
};

const mutations = {
  addPurchasable(state, purchasable) {
    if (!state.purchasables[purchasable.type]) {
      state.purchasables[purchasable.type] = {};
    }

    const itemUid = purchasable.item_uid;
    state.purchasables[purchasable.type][itemUid] = purchasable;
    state.uidIndex[purchasable.uid] = { type: purchasable.type, itemUid };
  },
};

const actions = {
  async getPurchasable({ commit, state, rootGetters }, { uid, type, itemUid }) {
    const accountCurrency = rootGetters['AccountStore/accountCurrency'] || 'USD';
    let purchasableValue = state.purchasables[type]?.[itemUid];

    if (!purchasableValue) {
      purchasableValue = await purchasableService.fetchPurchasable({
        uid,
        purchasable_type: type,
        item_uid: itemUid,
      });
      commit('addPurchasable', purchasableValue);
    }

    return purchasableValue[accountCurrency];
  },
  async getPurchasableByUid({ commit, state, rootGetters }, uid) {
    const purchasableIndex = state.uidIndex[uid];
    const purchasableParams = purchasableIndex ? {
      uid,
      type: purchasableIndex.type,
      itemUid: purchasableIndex.itemUid,
    } : { uid };

    return actions.getPurchasable({ commit, state, rootGetters }, purchasableParams);
  },
};

const getters = {
  purchasables: (state) => state.purchasables,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
